import styled from "styled-components";

export const RangeDatePickerStyled = styled.div`
  .ant-picker {
    width: 300px;
    width: 220px;
    max-height: 48px;
    height: 48px;
    background-color: #f5f5f5;
    border-radius: 12px;
    border: none;
    box-shadow: none;
    input {
      font-size: 12px;
    }
  }
`;
